import type { MagentoApiSetPaymentMethodOnCartMutationResponse } from "@jti/magento-api-v2";
import { MagentoGraphQLRequestClientError } from "@jti/magento-api-v2";

import { TAGS } from "../common/tags";
import type { MagentoApiBuilder } from "../magentoApiSlice";

export const setPaymentMethodOnCartEndpoint = (builder: MagentoApiBuilder) => ({
  setPaymentMethodOnCart: builder.mutation<
    MagentoApiSetPaymentMethodOnCartMutationResponse,
    { cartId: string; code: string }
  >({
    query: ({ cartId, code }) => ({
      method: "setPaymentMethodOnCart",
      params: [{ cartId, code }],
    }),
    transformErrorResponse: (error) => {
      if (!MagentoGraphQLRequestClientError.isMagentoGraphQLRequestClientError(error)) {
        return error;
      }

      const errorsDetails = error.errorsDetails;
      const message = errorsDetails ? errorsDetails[0].message : error.message;

      return { message };
    },
    invalidatesTags: [TAGS.CART_ORDER_PRICES, TAGS.AVAILABLE_PAYMENT_METHODS],
  }),
});
